export default class Endpoint {
  client

  constructor(client) {
    this.client = client
  }
}



// WEBPACK FOOTER //
// ../source/api/Endpoint.js